import type { ApolloCache } from "@apollo/client";
import { insertIntoConnection, removeFromConnection } from "#app/lib/data/connection-cache-utils";

export function addWebhookToCache(cache: ApolloCache, webhook: any) {
  insertIntoConnection(cache, "webhooks", "WebhookEdge", webhook);
}

export function removeWebhookFromCache(cache: ApolloCache, webhookId: string) {
  removeFromConnection(cache, "webhooks", { __typename: "Webhook", webhookId });
}
